import GlobalNav from './Shared/Components/Navbar/GlobalNav';
import HeroDisplay from './features/hero-display/HeroDisplay';
import ProductFeed from './features/product-feed/ProductFeed';
import TechnicalDataPage from './features/technical-data/TechnicalDataPage';
import FooterSection from './features/footer/FooterSection';
import HeroSlider from './features/imageSlider/HeroSlider';
import GuidanceSection from './features/guidance/GuidanceSection';
import WhatsAppFAB from './features/footer/WhatsAppFAB';
import { Helmet } from "react-helmet";
import { PRODUCT_SEARCH_FEED } from './Data/inventoryProvider';

function App() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": PRODUCT_SEARCH_FEED.map((product, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "item": {
        "@type": "Product",
        "name": product.name,
        "image": `https://www.busan.co.in${product.imageUrl}`,
        "description": `${product.name} with ${product.pressure} bar pressure capacity.`,
        "brand": { "@type": "Brand", "name": "Busan" },
        "offers": {
          "@type": "Offer",
          "availability": "https://schema.org/InStock",
          "priceCurrency": "INR"
        }
      }
    }))
  };
  return (
    <div className="app-wrapper">
      <Helmet>
        <title>Busan Hydraulic Rock Breaker for JCB & Excavators</title>
        <meta name="description" content="Top-quality Busan hydraulic rock breaker, JCB breaker, and excavator hydraulic rock breaker. Discover our premium rock breakers, hydraulic quick couplers, and more." />
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      </Helmet>
      <GlobalNav />

      <main>
        <HeroDisplay />

        <div className="container">
          <ProductFeed />
        </div>

        <TechnicalDataPage />
        <GuidanceSection videoId="uoiyNzi_z28" />
        <HeroSlider />
        <WhatsAppFAB />
      </main>

      <footer className="footer-minimal">
        <div className="container">
          <FooterSection />
        </div>
      </footer>
    </div>
  );
}

export default App;